import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/consts/skeletonSettings';

export const ListItemSkeleton = () => (
  <ContentLoader
    width={1200}
    height={62}
    title="Loading announcement item"
    uniqueKey="announcement-list-item-skeleton-date"
    viewBox="0 0 1200 62"
    {...DEFAULT_SETTINGS}>
    <rect x="20" y="8" width="625" height="20" rx="3" ry="3" />
    <rect x="20" y="33" width="215" height="20" rx="3" ry="3" />

    <rect x="1035" y="16" width="90" height="10" rx="3" ry="3" />
    <rect x="985" y="36" width="140" height="10" rx="3" ry="3" />
  </ContentLoader>
);
